import { createApp } from "vue";
import i18n from "../translations/i18n";
import CopernicaUnsubscribe from "../../components/CopernicaUnsubscribe";
import ModalVue from "../../components/ModalVue";

export const initializeCopernicaUnsubscribeApp = () => {
    if (!document.getElementById('js_copernicaunsubscribe')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('copernica-unsubscribe', CopernicaUnsubscribe);
    app.component('modal-vue', ModalVue);

    app.mount('#js_copernicaunsubscribe');
};
